import script from "./trueFalse.vue?vue&type=script&setup=true&lang=js"
export * from "./trueFalse.vue?vue&type=script&setup=true&lang=js"

import "./trueFalse.vue?vue&type=style&index=0&id=f4cbbba0&scoped=true&lang=css"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4cbbba0"]])

export default __exports__